<template>
  <div class="px-8 pt-4">
    <div class="d-flex align-items-center">
      <span class="symbol symbol-35 symbol-light-success mr-3">
        <span class="symbol-label font-size-h5 font-weight-bold">{{
          avatar
        }}</span>
      </span>
      <span class="text-white-50 font-weight-bolder font-size-base">
        <div>{{ user.name }}</div>
        <div class="w-auto d-flex align-items-center font-weight-normal">
          Город: {{ user.city.name }}
        </div>
        <div class="w-auto d-flex align-items-center font-weight-normal">
          Баланс: {{ formatNumber(user.balance) }}
        </div>
      </span>
    </div>
  </div>
</template>


<script>
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "KTQuickUser",
  data() {
    return {
      list: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    avatar() {
      let fio = this.user.name.split(" ");

      if (fio.length == 1) {
        return fio[0].charAt(0).toUpperCase();
      } else {
        return [fio[0].charAt(0), fio[1].charAt(0)].join("").toUpperCase();
      }
    },
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    formatNumber(value) {
      var formatter = new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
      });

      return formatter.format(value || 0);
    },
  },
};
</script>
